/**
 * The breakpoints, for scripts (tokens.css lists the same tiers for the stylesheets: custom
 * properties can't sit in a media query). Use these, never a hand-written number, so a
 * tier moves in one place for both.
 */

/** Width tiers, in CSS px. */
export const WIDTH = {
	/** A tablet: from here up to `wide`. */
	tablet: 700,
	/** Desktop and big tablets on their side: the shared shell (tokens.css --shell-max). */
	wide: 960,
} as const;

/** Height tiers, in CSS px: short phones step the masthead, the keys and the board down. */
export const HEIGHT = {
	landscape: 520,
	short: 700,
	medium: 800,
	tall: 900,
} as const;

const FINE = '(hover: hover) and (pointer: fine)';

/** Media queries, ready for `matchMedia`. "Wide" is always min-width 960; its complement 959.98. */
export const MEDIA = {
	wide: `(min-width: ${WIDTH.wide}px)`,
	notWide: `(max-width: ${WIDTH.wide - 0.02}px)`,
	tablet: `(min-width: ${WIDTH.tablet}px) and (max-width: ${WIDTH.wide - 0.02}px)`,
	/**
	 * A tab page in side-by-side columns (Today's grid, Play's rail, Stats' two columns): wide
	 * and wider than it's tall. An upright tablet keeps one column at --game-max (screens.css).
	 */
	columns: `(min-width: ${WIDTH.wide}px) and (min-aspect-ratio: 1/1)`,
	phoneLandscape: `(orientation: landscape) and (max-height: ${HEIGHT.landscape}px)`,
	finePointer: FINE,
	/**
	 * The game in two columns (J3): wide, with a mouse (and so a keyboard). The board on the
	 * left, the clue band and the clue list beside it, the drawn keys behind "Show keys". Touch
	 * keeps the drawn keys at any width.
	 */
	gameWide: `(min-width: ${WIDTH.wide}px) and ${FINE}`,
	/** The game's tablet tier (J3): a wider column, bigger cells and keys. Not a phone on its side. */
	gameTablet: `(min-width: ${WIDTH.tablet}px) and (min-height: ${HEIGHT.landscape + 0.02}px)`,
} as const;
